import type { DatabaseFieldType, DatabaseValue } from '@databases/types/database';

import { getFieldTypeRegistry } from './field-types.ts';

export function getInitialValue<Type extends DatabaseFieldType>(
  type: Type
): DatabaseValue<Type> {
  const registry = getFieldTypeRegistry();
  return {
    type,
    value: (registry[type] as { getInitialValue: () => unknown }).getInitialValue()
  } as DatabaseValue<Type>;
}
